import React, { Component } from "react";

import PlayerHorizontal from "../components/PlayerHorizontalComponent";
const PLAYER_VISIBLE = "playerVisible";
export default class iframe extends Component {
  constructor(props) {
    super(props);
    let playerVisible = localStorage.getItem(PLAYER_VISIBLE)
      ? JSON.parse(localStorage.getItem(PLAYER_VISIBLE))
      : { visibility: true };
    this.state = {
      mostraPlayer: playerVisible.visibility,
      iframeUrl: localStorage.getItem("getUrl"),
    };
  }
  showHorizontalPlayer = () => {
    let toggle = !this.state.mostraPlayer;
    this.setState(
      {
        mostraPlayer: toggle,
      },
      () =>
        localStorage.setItem(
          PLAYER_VISIBLE,
          JSON.stringify({ visibility: toggle })
        )
    );
  };
  render() {
    return (
      <>
        {this.state.iframeUrl && (
          <iframe
            width="100%"
            height="100%"
            id="framebj"
            src={this.state.iframeUrl}
            frameBorder="0"
          ></iframe>
        )}
        <PlayerHorizontal
          {...this.props}
          mostraPlayer={this.state.mostraPlayer}
          showHorizontalPlayer={this.showHorizontalPlayer}
        />
      </>
    );
  }
}
